import React, {useEffect, useState} from 'react';
import {useDropdowns} from "../../../../hooks/useDropdowns";
import {getDeviceDetails} from "../../../../Services/device";
import WorkforceDetailsFieldComponent from "../../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {Input, Select} from "antd";
import dayjs from "dayjs";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../../store/features/loadingSlice";
import {useDispatch, useSelector} from "react-redux";
import TextArea from "antd/es/input/TextArea";

const DownloadDataManualReadCaseDetails = () => {
    const {state} = useDropdowns();
    const { workforceCaseDetails } = useSelector((state) => state.Workforce);
    
    return (
        <div className="grid grid-cols-2 gap-5">

            <WorkforceDetailsFieldComponent fieldName={"Case ID"} fieldId={"caseIdStr"}>
                <Input
                    placeholder=""
                    id={"caseIdStr"}
                    disabled={true}
                    value={workforceCaseDetails?.caseIdStr}
                    onChange={(val) => {
                        // setTechnicianGroupData(val);
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Meter ID (Old)"}
                fieldId={"meterId"}
            >
                <Select
                    disabled={true}
                    showSearch
                    placeholder={"Select a value"}
                    value={workforceCaseDetails?.device?.meterSN}
                    options={state?.devices.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    })}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }

                    onChange={(val) => {
                    }}
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Creation Date"}
                fieldId={"creationDate"}
            >
                <Input
                    disabled={true}
                    id={"creationDate"}
                    value={workforceCaseDetails?.createdAt}
                    onChange={(val) => {
                        // setTechnicianGroupData(val);
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Meter Manufacturer"}
                fieldId={"meterManufacturer"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"meterManufacturer"}
                    value={workforceCaseDetails?.device?.meterMenufacturer}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Created By"}
                fieldId={"createdBy"}
            >
                <Input
                    disabled={true}
                    placeholder="someone@example.com"
                    id={"createdBy"}
                    value={workforceCaseDetails?.createdBy}
                    onChange={(val) => {
                        // setTechnicianGroupData(val);
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent fieldName={"Region"} fieldId={"region"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"region"}
                    value={workforceCaseDetails?.region} //
                    onChange={(val) => {
                        // setTechnicianGroupData(val);
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Case Type"}
                fieldId={"caseType"}
            >
                <Input
                    disabled={true}
                    value={workforceCaseDetails?.caseType?.name}
                    onChange={()=> {}}
                    placeholder="AIS01234333"
                    id={"caseType"}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Installation Date"}
                fieldId={"installationDate"}
            >
                <Input
                    disabled={true}
                    placeholder="AIS01234333"
                    id={"installationDate"}
                    value={workforceCaseDetails?.device?.installationDate}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Assign To"}
                fieldId={"assignTo"}
            >
                <Select
                    disabled={true}
                    placeholder={"Select a value"}
                    value={workforceCaseDetails?.technicianGroup?.name}
                    onChange={()=> {}}
                    id={"technicianGroupId"}
                    options={state?.technicianGroupsDropdown?.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    }) ?? []}
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Consumer Name"}
                fieldId={"consumerName"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"consumerName"}
                    value={workforceCaseDetails?.device?.consumerName}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent fieldName={"Logger Manufacturer"} fieldId={"loggerManufacturer"}
                                            className={"col-start-2"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"loggerManufacturer"}
                    value={workforceCaseDetails?.device?.loggerMenufacturer}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent fieldName={"Address"} fieldId={"address"} className={"col-start-2"}>
                <TextArea
                    disabled={true}
                    placeholder=""
                    id={"address"}
                    value={workforceCaseDetails?.fullAddress}
                />
            </WorkforceDetailsFieldComponent>
        </div>
    );

}

export default DownloadDataManualReadCaseDetails;